import React from 'react'
import { motion } from 'framer-motion'
import { Box, useMediaQuery } from '@material-ui/core'
import DynamicHUD from './DynamicHUD'
import DestinationPanel from './DestinationPanel'

const HUDOverlay = ({
  selectedDestination,
  onSelectDestination,
  onActivateResume,
  onActivateHRFAQ
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isSmall = useMediaQuery('(max-width: 1024px)')

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100,
        background: 'rgba(8, 8, 8, 0.97)',
        backdropFilter: 'blur(10px)'
      }}
    >
      {/* HUD chrome — pointer-events off so it never blocks clicks */}
      <div style={{ pointerEvents: 'none' }}>
        <DynamicHUD
          visible={true}
          onComplete={() => {}}
          persistent={true}
        />
      </div>

      {/* Content column that lives strictly inside the HUD safe zone */}
      <Box style={{
        position: 'absolute',
        top: isMobile ? '50px' : '60px',
        bottom: isMobile ? '60px' : '80px',
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '0.5rem 1rem' : '1rem 2rem',
        pointerEvents: 'none',
      }}>
        {/* LOCATION */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          style={{ textAlign: 'center', flexShrink: 0 }}
        >
          <div style={{
            fontFamily: '"Share Tech Mono", monospace',
            fontSize: isMobile ? '0.9rem' : isSmall ? '1.2rem' : '1.75rem',
            color: '#00ffff',
            letterSpacing: isMobile ? '0.08em' : isSmall ? '0.18em' : '0.3em',
            marginBottom: '0.3rem',
            textShadow: '0 0 10px rgba(0, 255, 255, 0.5)',
          }}>
            LOCATION: MAIN PLAZA
          </div>
          {!isMobile && (
            <div style={{
              fontFamily: '"Share Tech Mono", monospace',
              fontSize: isSmall ? '0.7rem' : '1.0rem',
              color: '#666',
              letterSpacing: isSmall ? '0.08em' : '0.2em'
            }}>
              COORDINATES: 37.7749°N, 122.4194°W
            </div>
          )}
        </motion.div>

        {/* Destination panels */}
        <Box style={{
          display: 'flex',
          gap: isMobile ? '1rem' : isSmall ? '2rem' : '4rem',
          maxWidth: '1400px',
          width: '100%',
          pointerEvents: 'auto',
          flexDirection: isMobile ? 'column' : 'row',
          flex: 1,
          alignItems: 'center',
          padding: isMobile ? '0.5rem 0' : '1rem 0',
          minHeight: 0,
        }}>
          <DestinationPanel
            destination="resume"
            isSelected={selectedDestination === 'resume'}
            onSelect={() => onSelectDestination('resume')}
            onClick={onActivateResume}
            imageSrc="/assets/img/cyberpunk/resume-storefront-cyan.png"
            title="レジュメ"
            description="Professional profile • 12+ years of experience"
            color="#00ffff"
          />
          <DestinationPanel
            destination="hrfaq"
            isSelected={selectedDestination === 'hrfaq'}
            onSelect={() => onSelectDestination('hrfaq')}
            onClick={onActivateHRFAQ}
            imageSrc="/assets/img/cyberpunk/hrfaq-storefront-magenta.png"
            title="人事部"
            description="Work authorization • Salary • Availability • Location"
            color="#ff00ff"
          />
        </Box>

        {/* NAVIGATE hint */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          style={{
            fontFamily: '"Share Tech Mono", monospace',
            fontSize: isMobile ? '0.7rem' : isSmall ? '0.9rem' : '1.4rem',
            color: '#00ffff',
            letterSpacing: isMobile ? '0.04em' : isSmall ? '0.1em' : '0.2em',
            textShadow: '0 0 10px rgba(0, 255, 255, 0.5)',
            textAlign: 'center',
            flexShrink: 0,
          }}
        >
          {isMobile ? 'TAP TO SELECT' : isSmall ? '← → NAVIGATE • ENTER TO SELECT' : '← → NAVIGATE DESTINATIONS • ENTER TO SELECT'}
        </motion.div>
      </Box>
    </motion.div>
  )
}

export default HUDOverlay
